import React from 'react';
import { number, func, string, bool } from 'prop-types';
import IconButton from '../IconButton/IconButton';
import { Plus, Minus, Delete } from '../IconButton/Icons';
import Counter from '../Counter';
import styles from './Quantity.scss';
import classNames from 'classnames';
import { Text } from 'wix-style-react';

export default function Quantity({
  value,
  min,
  max,
  onUpClick,
  onDownClick,
  className,
  small,
  allowDelete,
  onDelete,
  disabled,
}) {
  return (
    <Text
      size="medium"
      weight={small ? 'normal' : 'bold'}
      className={`${styles.wrapper} ${className}`}
      data-hook="cart-item-quantity-wrapper"
    >
      {allowDelete && value === min ? (
        <IconButton disabled={disabled} data-hook="delete-button" onClick={onDelete} small={small}>
          <Delete size={small ? 8 : 12} />
        </IconButton>
      ) : (
        <IconButton disabled={disabled || value <= min} data-hook="down-button" onClick={onDownClick} small={small}>
          <Minus size={small ? 8 : 12} />
        </IconButton>
      )}
      <Counter value={value} className={classNames([styles.counter, small && styles.small])} />
      <IconButton disabled={disabled || value >= max} data-hook="up-button" onClick={onUpClick} small={small}>
        <Plus size={small ? 8 : 12} />
      </IconButton>
    </Text>
  );
}

Quantity.displayName = 'Quantity';
Quantity.propTypes = {
  className: string,
  value: number,
  min: number,
  max: number,
  onUpClick: func,
  onDownClick: func,
  small: bool,
  allowDelete: bool,
  onDelete: func,
  disabled: bool,
};
Quantity.defaultProps = {
  min: -Infinity,
  max: Infinity,
};
